// components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// hooks
import { useMutation, useQueryClient } from 'react-query';

// queries & mutations
import { savePreference } from 'RestAPIs/preferences';

export type SavePreferencesPayload = [{ key: string; value: string }];

const useSavePreferences = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: SavePreferencesPayload) => savePreference(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['savePreferences']);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useSavePreferences;
